import React from "react";
import {
  TableContainer,
  Paper,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  useTheme,
} from "@mui/material";

interface AccountNamesTableProps {
  accountNames?: string[];
}

const AccountNamesTable: React.FC<AccountNamesTableProps> = ({ accountNames }) => {
  const theme = useTheme();

  return (
    <TableContainer
      component={Paper}
      sx={{
        boxShadow: "none",
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            <TableCell
              sx={{
                backgroundColor: theme.palette.common.white,
                fontWeight: "bold",
                textTransform: "uppercase",
                borderBottom: `1px solid ${theme.palette.divider}`,
                py: 1,
                px: 2,
              }}
            >
              Account Name
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {accountNames && accountNames.length > 0 ? (
            accountNames.map((name, index) => (
              <TableRow
                key={index}
                sx={{
                  backgroundColor:
                    index % 2 === 0
                      ? theme.palette.action.hover
                      : theme.palette.common.white,
                  "&:last-child td": {
                    borderBottom: "none",
                  },
                }}
              >
                <TableCell
                  sx={{
                    textAlign: "left",
                    borderBottom: "none",
                    py: 1,
                    px: 2,
                  }}
                >
                   {name}
                </TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell
                sx={{
                  textAlign: "center",
                  py: 2,
                  color: theme.palette.text.disabled,
                  borderBottom: "none",
                }}
              >
                No accounts
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AccountNamesTable;